import { render, staticRenderFns } from "./TenderAnnouncementsModal.vue?vue&type=template&id=4b0bb35d&scoped=true"
import script from "./TenderAnnouncementsModal.vue?vue&type=script&lang=js"
export * from "./TenderAnnouncementsModal.vue?vue&type=script&lang=js"
import style0 from "./TenderAnnouncementsModal.vue?vue&type=style&index=0&id=4b0bb35d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0bb35d",
  null
  
)

export default component.exports